import _api from '../_api';
import couponErrors from '../_api/couponErrors';

import Coupon from '../../../models/Coupon';

function formatUsersByIdsData (users, checked,) {
  return users.map((item,) => {
    const text = item?.first_name.concat(item?.last_name,).trim()
      || item?.email || item?.phone;
    return {
      ...item,
      text: text,
      checked,
    };
  },);
}

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    coupons: [],
    pageCount: 0,
    totalCount: 0,
    companyTypes: [],
    citiesData: {},
    companiesData: [],
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.coupons,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
    companyTypes: (state,) => state.companyTypes,
    cities: (state,) => state.citiesData,
    companies: (state,) => state.companiesData,
  },
  // -----------------------------------------------------------------
  mutations: {
    setCoupons: (state, coupons,) => (state.coupons = coupons),
    setPageCount: (state, pageCount,) => (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) => (state.totalCount = totalCount),
    setCompanyTypes: (state, companyTypes,) => (state.companyTypes = companyTypes),
    setCities: (state, cities,) => (state.citiesData = cities),
    setCompanies: (state, companies,) => (state.companiesData = companies),
  },
  // -----------------------------------------------------------------
  actions: {
    get: (
      { commit, },
      { page, _id, id, business_type, code, enabled, percent, franchises, cities, },
    ) => {
      commit('coupons/setCoupons', [], { root: true, },);

      return _api.get(
        { page, _id, id, business_type, code, enabled, percent, franchises, cities,},
      ).then(
        (response,) => {
          const coupons = response.data.coupons.map((coupon,) => new Coupon(coupon,),);
          commit('coupons/setCoupons', coupons, { root: true, },);
          commit(
            'coupons/setPageCount',
            Math.ceil(response.data.total_count / response.data.size,),
            { root: true, },
          );
          commit(
            'coupons/setTotalCount', response.data.total_count, {
              root: true,
            },);

          return coupons;
        },
        (error,) => {
          commit('coupons/setPageCount', 0, { root: true, },);
          commit('coupons/setTotalCount', 0, { root: true, },);
          return error;
        },
      );
    },
    create: async (_, value,) => {
      const newCoupon = new Coupon(value,).toPost;

      return new Promise((resolve, reject,) => {
        _api.
          post(newCoupon,).
          then(() => {
            resolve();
          },).
          catch((error,) => {
            const errorMessages = couponErrors(error.
              response.data.errors.map((err,) => err.slug,),);
            reject(errorMessages,);
          },);
      },);
    },
    // eslint-disable-next-line no-unused-vars
    enable ({ getters, }, _id,) {
      return _api.enableCoupon(_id,);
    },
    // eslint-disable-next-line no-unused-vars
    disable ({ getters, }, _id,) {
      return _api.disableCoupon(_id,);
    },
    // eslint-disable-next-line no-unused-vars
    remove ({ getters, }, _id,) {
      return _api.removeCoupon(_id,);
    },
    getCompanyTypes ({ commit, },) {
      return _api.getCompanyTypes().then(
        (response,) => {
          const types = {
            'RESTAURANT': 'Restaurante',
            'PHARMACY': 'Farmácia',
            'MARKET': 'Mercado',
            'PETSHOP': 'Petshop',
            'WATER_AND_GAS': 'Água e Gás',
            'OTHER': 'Outros',
          };
          const companyTypes = response.
            data.company_types.map((type,) => ({ key: type, value: types[type], }),);
          commit('coupons/setCompanyTypes', companyTypes, { root: true, },);
          return companyTypes;
        },
        (error,) => {
          return error;
        },);
    },
    // eslint-disable-next-line no-unused-vars
    getCities ({ commit, }, { franchises, page, search, size, from, },) {
      return _api.getCities({ franchises, page, search, size, from, },).then(
        (response,) => {
          const data = response.data;
          data.cities = [
            ...response.data.cities.map((city,) => {
              return {
                id: String(city.id,),
                text: `${city.name} - ${city.state.acronym}`,
                checked: false,
                visible: false,
              };
            },),
          ];

          commit('coupons/setCities', data, { root: true, },);
          return data;
        },
        (error,) => {
          console.error(error,);
        },
      );
    },
    // eslint-disable-next-line no-unused-vars
    getCitiesByIds ({ commit, }, citiesIds,) {
      return _api.getCitiesByIds(citiesIds,).then(
        (response,) => {
          const data = {
            cities: [],
            total: response.data.cities.length,
          };
          data.cities = [
            ...response.data.cities.map((city,) => {
              return {
                id: String(city.id,),
                text: city.name,
                checked: true,
                visible: false,
              };
            },),
          ];
          return data;
        },
        (error,) => {
          console.log(error,);
        },
      );
    },
    // eslint-disable-next-line no-unused-vars
    getCompanies ({ commit, }, { franchises, page, search, size, from, },) {
      return _api.getCompanies({ franchises, page, search, size, from, },).then(
        (response,) => {
          const data = response.data;
          data.companies = [
            ...response.data.companies.map((company,) => {
              return {
                uuid: company.uuid,
                text: `${company.name} - ${company.city} - ${company.uf}`,
                checked: false,
                visible: false,
              };
            },),
          ];
          commit('coupons/setCompanies', data, { root: true, },);
          return data;
        },
        (error,) => {
          console.error(error,);
        },
      );
    },
    // eslint-disable-next-line no-unused-vars
    getCompaniesByIds ({ commit, }, companiesIds,) {
      return _api.getCompaniesByIds(companiesIds,).then(
        (response,) => {
          const data = response.data;
          data.companies = [
            ...response.data.companies.map((company,) => {
              return {
                uuid: company.uuid,
                text: `${company.name} - ${company.city} - ${company.uf}`,
                checked: true,
                visible: false,
              };
            },),
          ];
          return data;
        },
        (error,) => {
          console.error(error,);
        },
      );
    },
    // eslint-disable-next-line no-unused-vars
    getUsersByEmailPhone ({commit,}, {email, phone,},) {
      return new Promise((resolve, reject,) => {
        _api.getUsersByEmailPhone({email, phone,},).
          then((response,) => {
            const user = {
              ...response.data,
              text: `${response.data.first_name} ${response.data.last_name}`,
              checked: false,
            };
            resolve(user,);
          },).
          catch((error,) => {
            reject(error.response.data.errors.message,);
          },);
      },);
    },

    getUsersByIds (_, users,) {
      return _api.getUsersByIds(users,).then(
        (response,) => {
          return formatUsersByIdsData(response.data, true,);
        },);
    },

    getNewUsersByIds (_, users,) {
      return _api.getUsersByIds(users,).then(
        (response,) => {
          return formatUsersByIdsData(response.data, false,);
        },);
    },
  },
};
